<template>
  <div class='out-wrap'>
    <h3>基本信息</h3>
    <van-form ref="form">
      <van-field colon required v-model.trim="base_info.name" name='姓名' label="姓名" placeholder="请输入姓名,如：李白" :rules="[{ required: true, message: '请输入姓名'}]"/>
      <van-field colon required  v-model.trim="base_info.name_pinyin" name="姓名拼音" label="姓名拼音" placeholder="请输入姓名拼音，如：libai" :rules="[{ required: true, message: '请输入姓名拼音'},{ pattern: /^[a-z]+$/, message: '注意是拼音哦'}]"/>
      <van-field colon required maxlength="2" v-model.trim="base_info.title" ref='title' name='字' label="字" placeholder="请输入字，如：太白" :rules="[{ required: true, message: '请输入字'}]"/>
      <van-field colon required v-model.trim="base_info.apply_job_name"  name='岗位' label="岗位" placeholder="请输入岗位名称" :rules="[{ required: true, message: '请输入岗位名称'}]"/>
      <van-field colon required maxlength="18" type="digit" @input='fillCardId(base_info.id_card_num)' v-model.trim="base_info.id_card_num" name="身份证号码" label="身份证号码" placeholder="请输入身份证号码"  :rules="[{required: true, message: '请输入身份证号' },{ pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '证件号码格式错误'}]"/>
      <van-field colon required readonly clickable :value=" base_info.sex | tTov(sexList, base_info.sex)" label="性别" name="性别" placeholder="点击选择性别" right-icon="arrow" @click="sexPicker = true"/>
      <van-popup v-model.trim="sexPicker" position="bottom">
        <van-picker show-toolbar value-key='t' :columns="sexList" @confirm="pickerConfirm($event, 'sex')" @cancel="sexPicker = false"/>
      </van-popup>
      <van-field colon required readonly clickable name="出生年月日" :value="base_info.born_time" label="出生年月日" placeholder="请选择出生年月日" right-icon="arrow" :rules="[{ required: true, message: '请选择出生年月日' }]" @click="born_timePicker = true"/>
      <van-popup v-model.trim="born_timePicker" position="bottom">
        <van-datetime-picker :min-date="minDate" type="date" @confirm="pickerConfirm($event, 'born_time')" @cancel="born_timePicker = false"/>
      </van-popup>
      <van-field colon required readonly clickable name="民族" :value="base_info.race | tTov(raceList, base_info.race)" label="民族" placeholder="请点击选择民族" right-icon="arrow" :rules="[{ required: true, message: '请点击选择民族' }]" @click="racePicker = true"/>
      <van-popup v-model.trim="racePicker" position="bottom">
        <van-picker show-toolbar value-key='t' :columns="raceList" @confirm="pickerConfirm($event, 'race')" @cancel="racePicker = false"/>
      </van-popup>
      <van-field colon required v-model.trim="base_info.personal_email" name='邮箱' label="邮箱" placeholder="请输入邮箱" :rules="[{ required: true, message: '请输入邮箱'},{ pattern: /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/, message: '邮箱格式错误'}]"/>
      <van-field colon required v-model.trim="base_info.phone" maxlength="11" type="tel" name='手机号码' label="手机号码" placeholder="请输入手机号码" :rules="[{ required: true, message: '请输入手机号码'},{ pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误'}]"/>
        <van-field colon required readonly clickable name="籍贯" :value="base_info.regist_address" label="籍贯" placeholder="请点击选择籍贯" @click="regist_addressPicker = true" right-icon="arrow" :rules="[{ required: true, message: '请点击选择籍贯'}]"/>
        <van-popup v-model.trim="regist_addressPicker" position="bottom">
          <van-area :columns-num='2' :value='setJiguanAddress' :area-list="regist_addressList" @confirm="pickerConfirm($event, 'regist_address', 'address')" @cancel="regist_addressPicker = false"/>
        </van-popup>
        <van-field colon required readonly clickable :value="base_info.regist_type | tTov(regist_typeList, base_info.regist_type)" name='户口性质' label="户口性质" :rules="[{ required: true, message: '请点击选择户口性质'}]" placeholder="请点击选择户口性质" right-icon="arrow" @click="regist_typePicker = true"/>
        <van-popup v-model.trim="regist_typePicker" position="bottom">
          <van-picker show-toolbar value-key='t' :columns="regist_typeList" @confirm="pickerConfirm($event, 'regist_type')" @cancel="regist_typePicker = false"/>
        </van-popup>
        <van-field colon required readonly clickable name="身份证住址" :value="base_info.id_place" label="身份证住址" placeholder="请点击选择身份证省市区" @click="id_placePicker = true" right-icon="arrow" :rules="[{ required: true, message: '请点击选择身份证省市区'}]"/>
        <van-popup v-model.trim="id_placePicker" position="bottom">
          <van-area :area-list="regist_addressList" @confirm="pickerConfirm($event, 'id_place', 'address')" @cancel="id_placePicker = false"/>
        </van-popup>
        <van-field colon required v-model.trim="base_info.id_place_details" clearable name="身份证详细地址" label="详细地址" placeholder="请输入身份证详细地址" :rules="[{ required: true, message: '请输入身份证详细地址'}]"/>
        <van-field colon required readonly clickable name="政治面貌" :value="base_info.political_experience | tTov(political_experienceList, base_info.political_experience)" label="政治面貌" placeholder="请点击选择政治面貌" right-icon="arrow" :rules="[{ required: true, message: '请点击选择政治面貌'}]" @click="political_experiencePicker = true"/>
        <van-popup v-model.trim="political_experiencePicker" position="bottom">
          <van-picker show-toolbar value-key='t' :columns="political_experienceList" @confirm="pickerConfirm($event, 'political_experience')" @cancel="political_experiencePicker = false"/>
        </van-popup>
        <van-field colon required name="婚姻状况" label="婚姻状况">
          <template #input>
            <van-radio-group checked-color='#edad57' v-model="base_info.marry" direction="horizontal">
              <van-radio name="1">未婚</van-radio>
              <van-radio name="4">离异</van-radio>
              <van-radio name="2">已婚未育</van-radio>
              <van-radio name="3">已婚已育</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-if='base_info.marry == "3"' name="已育几孩" label="已育几孩">
          <template #input>
            <van-stepper v-model="base_info.childNum" />
          </template>
        </van-field>

        <van-field colon name="健康状况" label="健康状况">
          <template #input>
            <van-radio-group checked-color='#edad57' v-model="base_info.health" direction="horizontal">
              <van-radio name="1">良好</van-radio>
              <van-radio name="2">一般</van-radio>
              <van-radio name="3">有疾病</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field colon v-if='base_info.health == "3"' v-model.trim="base_info.no_health_reason" rows="2" autosize  type='textarea' clearable label="疾病说明" placeholder="请填写您的疾病"/>
        <van-field colon  v-model.trim="base_info.specialty" name='特长' label="特长" placeholder="请输入个人兴趣爱好或特长" />
      <div style="margin: 16px;">
        <van-button class='submit-btn' block type="info" @click="nextStep">下一步</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { getStore, setStore } from '../../../utils/localStore';
import moment from "moment";
import _ from 'lodash';
import regist_addressList from "../../../assets/js/area";
import {request} from "../../../utils/request";
import API from "../../../utils/API";

export default {
  data() {
    return {
      base_info: {
        name: '',
        name_pinyin:'',
        title: '',
        phone: '',
        born_time: '',
        grade: this.CONSTANT.human.staff.grade.employee.v,
        sex: this.CONSTANT.human.staff.sex.man.v,
        personal_email: '',
        email: '',
        regist_address: '',//户籍地址
        regist_type: '' , //户籍类型
        political_experience: '',//政治面貌
        race: this.CONSTANT.human.staff.race_list[0].v,//民族
        marry:'1',//婚育情况
        health: '1',
        childNum: 1,
      },
      gradeList: [],
      gradePicker: false,
      sexList: [],
      sexPicker: false,
      born_timePicker: false,
      minDate: new Date(1970, 0, 1),
      raceList: [],
      racePicker: false,
      regist_addressList,
      regist_addressPicker: false,
      setJiguanAddress: "440106",
      contact_addressPicker: false,
      id_placePicker: false,
      political_experiencePicker: false,
      political_experienceList: [],
      regist_typeList: [],
      regist_typePicker: false,
    }
  },
  mounted() {
    //获取下拉选项所需数据  本地获取
    this.gradeList = this.CONSTANT.human.staff.grade.list();
    this.sexList = this.CONSTANT.human.staff.sex.list();
    this.raceList = this.CONSTANT.human.staff.race_list;
    this.political_experienceList = this.CONSTANT.human.staff.political_experience.list();
    this.regist_typeList = this.CONSTANT.human.staff.regist_type.list();
    
    this.$nextTick(() => {
      let data = getStore({name: 'applyInfo'});
      let formdata = this.getData('submitBaseInfo');
      if(formdata){
        this.base_info = formdata;
      }else{
        this.baseInfoInit(data)
      }
    })
  },
  beforeRouteLeave(to, from, next){
      this.setData(this.base_info, 'submitBaseInfo', '2h')
      next()  
  },
  methods: {
    baseInfoInit(data){
      this.base_info.name = data.name;
      this.base_info.id_card_num = data.card_id;
      this.fillCardId(data.card_id)
      this.base_info.personal_email = data.e_mail;
      this.base_info.phone = data.phone;
      this.base_info.contact_address = data.now_address;
      this.base_info.contact_place_details = data.address_details;
      this.base_info.specialty = data.interest;
      this.base_info.apply_job_name = data.apply_job_name;
    },
    pickerConfirm(val,type,spec='') { //统一方法替换
      if(spec){
        let str = ''
        _.map(val, item => {
          if(val.length == 2){
            str += item.name+' '
          }else{
            str += item.name+'/'
          }
        })
        str = str.substring(0, str.length -1)
        this.base_info[type] = str;
      }else{
        this.base_info[type] = !val.v ? moment(val).format('YYYY-MM-DD') : val.v;
      }
      let picker = type+'Picker'
      this[picker] = false;
    },
    fillCardId(val){ //身份证数据匹配
        let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if(reg.test(val)){
          let year = val.substr(6, 4);
          let month = val.substr(10, 2); 
          let day = val.substr(12, 2);
          let sex = val.substring(16, 17);
          sex = sex % 2
          if(sex == 1){
            this.base_info.sex = sex
          }else{
            this.base_info.sex = sex;
          }
          this.base_info.born_time = year+'-'+month+'-'+day;
        }
      },
    setData(data, name, time) {
      setStore({
        name,
        content: data,
        options: {
          expiry: time
        }
      })
    },
    getData(name) {
      return getStore({name});
    },
    nextStep() {
      // console.log(this.base_info)
      // return
      /* 
      1、校验必填项是否填写
      2、检验字是否有重复
      3、缓存数据到本地
      */
     //校验必填项
      this.$refs.form.validate().then(res => {
          //差点忘记拼接公司邮箱
          this.base_info.email = this.base_info.name_pinyin+'@honyup.com';
          // 1、缓存数据
          this.setData(this.base_info, 'submitBaseInfo', '2h')
          //2、校验数据
          request({
            method: 'get',
            url: API.CHECKOUT_BASEINFO,
            data: {
                name_or_title: this.base_info.title
            }
          }).then(data => {
            let resData = data.data.data.list, staff_id = this.$route.query.staff_id;
            let index = resData.findIndex(value => {
                return value.staff_id == staff_id
              }) 
            if(resData.length >= 0 && index == -1){
              this.$toast.fail('您的字很受欢迎，已存在，请重新输入！')
              this.base_info.title = '';
              this.$refs.title.focus();
              window.scrollTo(0,0)
            }else{
              this.$router.push({
                  path:'/induction_value',
                  query:{
                    id: this.$route.query.id,
                    staff_id: this.$route.query.staff_id,
                    type: this.$route.query.type,
                    page: 'education'
                  }
              })
            }
          }).catch(() => {
            this.$toast.fail('系统错误！')
          })
          // console.log(res,'成功')
        }).catch((err) => {
          this.$toast({
            message: `请填写${err[0].name}`,
            duration: 2500
          })
          return
      })
    }
  }

}
</script>

<style lang='less' scoped>
@import "../../../assets/css/page.css";
@import "../../../assets/css/wrap.css";
</style>